/* eslint-disable @typescript-eslint/no-explicit-any */
export const escDown = (event: KeyboardEvent, callBack: (...args: any[]) => void) => {
  event.preventDefault()
  if (callBack) {
    callBack()
  }
}

export const escUp = (event: KeyboardEvent, callBack: (...args: any[]) => void) => {
  event.preventDefault()
  if (callBack) {
    callBack()
  }
}
